import { render, staticRenderFns } from "./auth-app.vue?vue&type=template&id=2250897a&scoped=true"
import script from "./auth-app.vue?vue&type=script&lang=js"
export * from "./auth-app.vue?vue&type=script&lang=js"
import style0 from "./auth-app.vue?vue&type=style&index=0&id=2250897a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2250897a",
  null
  
)

export default component.exports